import { render } from "./Equities.vue?vue&type=template&id=775bc4c6&scoped=true"
import script from "./Equities.vue?vue&type=script&lang=js"
export * from "./Equities.vue?vue&type=script&lang=js"

import "./Equities.vue?vue&type=style&index=0&id=775bc4c6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775bc4c6"]])

export default __exports__